import { createContext, useContext } from "react";

export type IModalManagerContext = {
  onClose: () => void;
  prompt?: boolean;
  showModal: boolean;
  fullScreen?: boolean;
  modalSize?: "s" | "m";
  scrollable?: boolean;
};

export const ModalManagerContext = createContext<IModalManagerContext>(
  {} as any
);

export const useModalManagerContext = () => useContext(ModalManagerContext);
